import { Component, OnInit } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { take } from 'rxjs/operators';
import {
  clearAuthStateForRelogin,
  consumeForbiddenReturnUrl,
  peekForbiddenReturnUrl,
} from 'src/app/shared/services/token.util';

@Component({
  selector: 'app-forbidden',
  templateUrl: './forbidden.component.html',
  styleUrls: ['./forbidden.component.css'],
})
export class ForbiddenComponent implements OnInit {
  userName = '';
  userEmail = '';
  userRole = '';
  returnUrl = '/';

  constructor(public auth: AuthService) {}

  ngOnInit(): void {
    this.returnUrl = peekForbiddenReturnUrl('/');
    this.userRole = localStorage.getItem('role') || '';

    this.auth.user$.pipe(take(1)).subscribe((user) => {
      this.userEmail = user?.email || '';
      this.userName =
        user?.name || user?.nickname || user?.email || '';
    });
  }

  login(): void {
    const target = consumeForbiddenReturnUrl(this.returnUrl || '/');
    clearAuthStateForRelogin();

    this.auth.loginWithRedirect({
      authorizationParams: {
        prompt: 'login',
      },
      appState: { target },
    });
  }
}
